import { axiosWithAuth } from "helpers";

export const merchantFinancialService = {
	addFinancials,
	addBankBalances,
};

const API_URL = process.env.REACT_APP_API_URL;

function addFinancials(merchantId, financials) {
	const options = {
		method: "POST",
		data: { financials },
		url: `${API_URL}/api/merchants/${merchantId}/financials/add-range`,
	};

	return axiosWithAuth(options);
}

function addBankBalances(merchantId, bankBalances) {
	const options = {
		method: "POST",
		data: { bankBalances },
		url: `${API_URL}/api/merchants/${merchantId}/bank-balances/add-range`,
	};

	return axiosWithAuth(options);
}
